import { makeStyles } from "@material-ui/core"
import React from "react"
import {
  COLOR_BORDER_LIGHT,
  COLOR_HEADER_BG,
  COLOR_PRIMARY,
  COLOR_PRIMARY_DARK,
  COLOR_SURFACE_LIGHT,
  COLOR_TEXT_BORDER,
  COLOR_TOTAL_BG,
  COLOR_WARNING,
} from "./constants"

// Estilo inline compartido para la fila de totales
export const totalCellStyle: React.CSSProperties = {
  backgroundColor: COLOR_TOTAL_BG,
  color: "#fff",
  fontWeight: "bold",
  fontSize: "0.75rem",
  borderRight: `1px solid ${COLOR_HEADER_BG}`,
  position: "sticky",
  bottom: 0,
  zIndex: 3,
}

// Styles compartidos entre SaleReportGrid y SammaryReport
export const useDashboardStyles = makeStyles({
  toolbar: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    gap: 4,
    paddingRight: 4,
  },
  downloadButton: {
    fontSize: "0.75rem",
    padding: "4px 12px",
    borderColor: COLOR_PRIMARY,
    color: COLOR_PRIMARY,
    borderRadius: 8,
    textTransform: "none",
    marginRight: 4,
  },
  popoverHeader: {
    background: `linear-gradient(135deg, ${COLOR_PRIMARY} 0%, ${COLOR_PRIMARY_DARK} 100%)`,
    padding: "14px 16px 12px 20px",
    borderRadius: "16px 16px 0 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  popoverHeaderTitle: {
    fontWeight: 700,
    fontSize: 15,
    color: "#fff",
    letterSpacing: 0.3,
  },
  popoverActions: {
    display: "flex",
    gap: 8,
    padding: "10px 16px 8px",
    backgroundColor: COLOR_SURFACE_LIGHT,
    borderBottom: `1px solid ${COLOR_BORDER_LIGHT}`,
  },
  popoverFooter: {
    borderTop: `1px solid ${COLOR_BORDER_LIGHT}`,
    padding: "8px 18px",
    backgroundColor: COLOR_SURFACE_LIGHT,
    borderRadius: "0 0 16px 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  draggableRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "7px 16px",
    cursor: "grab",
    transition: "all 0.15s",
    userSelect: "none",
  },
  headerCell: {
    backgroundColor: COLOR_HEADER_BG,
    color: "#fff",
    fontWeight: "bold",
    borderRight: `1px solid ${COLOR_TEXT_BORDER}`,
    fontSize: "0.75rem",
  },
  dataCell: {
    borderRight: `1px solid ${COLOR_TEXT_BORDER}`,
    fontSize: "0.75rem",
  },
  fixedCell: {
    borderRight: `1px solid ${COLOR_TEXT_BORDER}`,
    fontSize: "0.75rem",
    backgroundColor: COLOR_HEADER_BG,
    color: "#fff",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px 0",
    gap: 10,
    position: "sticky",
    left: 0,
  },
  filterCategoryChip: {
    display: "inline-flex",
    alignItems: "center",
    backgroundColor: COLOR_WARNING,
    borderRadius: 20,
    padding: "2px 10px",
    marginLeft: 2,
    marginBottom: 4,
  },
  filterChipsContainer: {
    backgroundColor: COLOR_SURFACE_LIGHT,
    borderRadius: "10px",
    padding: 10,
    minHeight: "100px",
    maxHeight: "200px",
    overflowY: "auto",
    border: `1px solid ${COLOR_BORDER_LIGHT}`,
  },
})
